import React from 'react';

const RowList = ({ telegramUserId, userName, videoName, dayStatus, timestamp, courseNumber }) => {
    const getStatusColor = (status) => {
        switch (status) {
            case 'Утро': return '#e3f2fd';
            case 'День': return '#e8f5e9';
            case 'Вечер': return '#fff8e1';
            default: return '#f5f5f5';
        }
    };

    return (
        <tr className="data-row">
            <td>{courseNumber}</td>
            <td>{telegramUserId}</td>
            <td>{userName}</td>
            <td>{videoName}</td>
            <td>
                <span className="day-status" style={{ backgroundColor: getStatusColor(dayStatus) }}>
                    {dayStatus}
                </span>
            </td>
            <td>{timestamp}</td>

            <style>{`
                .data-row {
                    transition: background-color 0.2s;
                }
                
                .data-row:hover {
                    background-color: #f8f9fa;
                }
                
                .data-row td {
                    padding: 12px 15px;
                    border-bottom: 1px solid #dee2e6;
                }

                .day-status {
                    display: inline-block;
                    padding: 4px 10px;
                    border-radius: 12px;
                    font-size: 13px;
                    color: #333;
                }
            `}</style>
        </tr>
    );
};

export default RowList;